module.exports = __webpack_public_path__ + "media/images/categories/icon_cat18-2a76d62ad9f4c3b016b7e0d9560f35e2.svg";